export default __webpack_public_path__ + "static/media/Front-Villa-Mr-Mkahal.3e9136b3.jpg";